import { cn } from '../../lib/cn.ts';

export interface WorkingPageProps {
  className?: string;
}

/* Static strings so Tailwind finds them; one row per line of the page. */
const LINES = ['w-3/5 h-1.5 bg-accent', 'w-full delay-400', 'w-4/5 delay-800'] as const;

/**
 * Wundo is writing something for you: a small page whose lines are written
 * out one after another. Decoration only — the words beside it say what is
 * being written. Without motion the page stands half-written, caret showing.
 */
export function WorkingPage({ className }: WorkingPageProps) {
  return (
    <span
      data-slot='working-page'
      aria-hidden='true'
      className={cn(
        'flex h-16 w-13 flex-col gap-1.5 rounded-sm border border-line bg-canvas px-2.5 py-2.5 shadow-hover',
        className,
      )}
    >
      {LINES.map((line, index) => (
        <span
          key={index}
          className={cn(
            'block h-1 origin-left animate-write rounded-full bg-ink-faint motion-reduce:animate-none',
            line,
          )}
        />
      ))}
      <span className='flex items-center gap-0.5'>
        <span className='block h-1 w-2/5 origin-left animate-write rounded-full bg-ink-faint delay-1200 motion-reduce:animate-none' />
        <span className='block h-2.5 w-0.5 animate-pulse rounded-full bg-primary motion-reduce:animate-none' />
      </span>
    </span>
  );
}
